import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import Auth from "../components/Auth";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Privacidade from "../components/Privacidade";
import CadastroImovel from "../pages/CadastroImovel";
import DashboardImoveis from "../pages/Dashboard";
import Error from "../pages/Error";
import Home from "../pages/Home";
import Imovel from "../pages/Imovel"
import Login from "../pages/Login";

const RouterApp = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header/>
        <Routes>
            {/* Rotas públicas */}
            <Route path="/" element={<Home/>}/>
            <Route path="/about" element={<Banner/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/privacidade" element={<Privacidade/>}/>
            <Route path="/imovel/:slug" element={<Imovel />} />
            
            {/* Rotas protegidas */}
            <Route path="/dashboard" element={<Auth><DashboardImoveis /></Auth>} />
            <Route path="/dashboard/cadastrar" element={<Auth><CadastroImovel /></Auth>} />
            {/* <Route path="/dashboard" element={<DashboardImoveis />} />
            <Route path="/dashboard/cadastrar" element={<CadastroImovel />} /> */}
            
            {/* Rota de erro */}
            <Route path="*" element={<Error/>}/>
        </Routes>
      </AuthProvider>  
      <Footer/>
    </BrowserRouter>
  )
}

export default RouterApp;